import { makeStyles } from '@material-ui/core/styles'
import { backgroundBeans } from '../../assets/images'

export default makeStyles(theme => ({
  root: {
    height: '100%',
    minHeight: '100vh',
    backgroundColor: '#fff',
    background: `#fff url(${backgroundBeans}) repeat scroll 0% 0%`,
    display: 'flex',
    flexFlow: 'column'
  },
  neBeanBackground: {
    backgroundImage: 'none'
  },
  footerContent: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    alignContent: 'stretch'
  },
  footerInner: {
    flex: 1,
    overflowX: 'hidden',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  footer: {
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '1140px'
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '960px'
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '720px'
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '540px'
    }
  },
  footerList: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    listStyle: 'none',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  footerListItem: {
    color: '#9898b3',
    fontSize: '16px',
    fontWeight: 300,
    display: 'flex',
    flexDirection: 'row',
    '&:not(:last-child):after': {
      content: "' | '",
      color: '#9898b3',
      paddingLeft: '15px',
      paddingRight: '15px'
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: '15px',
      flexDirection: 'column',
      '&:last-child': {
        marginBottom: 0
      },
      '&:not(:last-child):after': {
        display: 'none'
      }
    }
  },
  footerLink: {
    color: '#9898b3',
    fontSize: '14px',
    fontWeight: 300,
    textDecoration: 'underline'
  }
}))
